import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  IconButton,
  Container,
  Snackbar,
  Alert,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import LibrarySettings from './LibrarySettings';
import DesktopNav from '../../components/DesktopNav';
import LibrarianBottomNav from '../../components/LibrarianBottomNav';

function LibrarySettingsPage() {
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'transparent' }}>
      <DesktopNav />

      <Box sx={{ minHeight: 'calc(100vh - 64px)', pb: '90px' }}>
        <Container maxWidth="lg" sx={{ py: 3 }}>
          {/* Header with Back Button */}
          <Box display="flex" alignItems="center" gap={2} mb={3}>
            <IconButton
              onClick={() => navigate('/librarian/manage')}
              sx={{
                bgcolor: 'action.hover',
                '&:hover': { bgcolor: 'action.selected' },
              }}
            >
              <ArrowBack />
            </IconButton>
          </Box>

          <LibrarySettings showSnackbar={showSnackbar} />
        </Container>
      </Box>

      <LibrarianBottomNav />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default LibrarySettingsPage;
